import {Guide} from '../models/guide/dto/guide';

export class UniqueUtils {
  static guideId = (a: Guide, b: Guide): boolean => {
    return a?.id === b?.id;
  }
}
